import type { FC } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import GridErrorBoundaryFallback from './GridErrorBoundaryFallback';
import Form from './GoToTestForm';

const AddGoToTest: FC = () => {
  return (
    <ErrorBoundary FallbackComponent={GridErrorBoundaryFallback}>
      <Form />
    </ErrorBoundary>
  );
};

export default AddGoToTest;